module.exports = {
	"zh-CN": [
		{
			"name": "ZanUI组件",
			"groups": [
				{
					"groupName": "CSS组件",
					"list": [
						{
							"path": "/button",
							"title": "Button"
						},
						{
							"path": "/cell",
							"title": "Cell"
						},
						{
							"path": "/progress",
							"title": "Progress"
						},
						{
							"path": "/panel",
							"title": "Panel"
						},
						{
							"path": "/card",
							"title": "Card"
						},
						{
							"path": "/loading",
							"title": "Loading"
						},
						{
							"path": "/steps",
							"title": "Steps"
						},
						{
							"path": "/tag",
							"title": "Tag"
						},
						{
							"path": "/badge",
							"title": "Badge"
						},
						{
							"path": "/search",
							"title": "Search"
						}
					]
				},
				{
					"groupName": "Form",
					"list": [
						{
							"path": "/switch",
							"title": "Switch"
						},
						{
							"path": "/field",
							"title": "Field"
						},
						{
							"path": "/radio",
							"title": "Radio"
						},
						{
							"path": "/checkbox",
							"title": "Checkbox"
						}
					]
				},
				{
					"groupName": "JS组件",
					"list": [
						{
							"path": "/tab",
							"title": "Tab"
						},
						{
							"path": "/toast",
							"title": "Toast"
						},
						{
							"path": "/img-uploader",
							"title": "Img Uploader"
						},
						{
							"path": "/picker",
							"title": "Picker"
						},
						{
							"path": "/datetime-picker",
							"title": "Datetime Picker"
						},
						{
							"path": "/lazyload",
							"title": "Lazyload"
						},
						{
							"path": "/popup",
							"title": "Popup"
						},
						{
							"path": "/dialog",
							"title": "Dialog"
						},
						{
							"path": "/swipe",
							"title": "Swipe"
						},
						{
							"path": "/waterfall",
							"title": "Waterfall"
						},
						{
							"path": "/img-preview",
							"title": "Img Preview"
						}
					]
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./docs/nav.config.json
// module id = 7
// module chunks = 2 3